export function transform(str: string, ch: string, fn: (s: string) => string) {
  return str?.split(ch).map(fn).join(ch);
}

export function ucFirst(chunk: string): string {
  return chunk[0]?.toLocaleUpperCase() + chunk.substring(1);
}

export function toTitleCase(str: string): string {
  return transform(transform(str, "-", ucFirst), " ", ucFirst)
    ?.replaceAll("-", " ")
    ?.replaceAll("_", " ");
}

export function toTitleCaseOdds(str: string): string {
  return transform(transform(str, "_", ucFirst), " ", ucFirst)?.replaceAll(
    "_",
    " ",
  );
}

export function formatNumber(num: number) {
  if (!num) return 0;
  const whole = num.toFixed();
  const chunks: string[] = [];
  for (let i = whole.length; i >= 0; i -= 3) {
    chunks.push(whole.substring(i - 3 > 0 ? i - 3 : 0, i) + ",");
  }
  const preprocessed = chunks.reverse().join("").trimEnd();
  const withoutFirst = preprocessed.startsWith(",")
    ? preprocessed.slice(1)
    : preprocessed;
  const processed = withoutFirst.endsWith(",")
    ? withoutFirst.slice(0, -1)
    : withoutFirst;
  return <span className="whitespace-nowrap">{processed}</span>;
}

export function currentTimeAfter(timestamp: string) {
  const date = new Date(timestamp);
  const now = Date.now();

  return +now > +date;
}

export function currentTimeBefore(timestamp: string) {
  const date = new Date(timestamp);
  const now = Date.now();
  return +now < +date;
}

export function shortId(id: string) {
  if (!id) {
    return "";
  }
  return id.substring(0, 3) + "..." + id.substring(id.length - 3, id.length);
}
